import { createSelector } from '@reduxjs/toolkit';
import { getBrowser } from '../browser/selectors';
import { getFromImmutableState } from '../../../../../utils/immutableUtils';
import { _getHotelsList } from '../hotels/selectors';

export const _getMapProps = (state) => state.get('map');
export const getMapProps = getFromImmutableState(_getMapProps);
export const getAllHotels = (state) => _getMapProps(state).get('hotels');
export const getHotelsInList = (state) =>
  _getMapProps(state).get('hotelsInList');
export const getActiveHotel = (state) => _getMapProps(state).get('activeHotel');
export const getFilteredHotels = (state) =>
  _getMapProps(state).get('filteredHotels');
export const isMapView = createSelector(
  [_getMapProps, getBrowser],
  (mapProps, browser) =>
    Boolean(mapProps.get('expanded') && browser.lessThan.infinity),
);
export const popupDataSelector = createSelector(
  [getMapProps],
  (map) => map.popupData,
);
export const getHotelsList = getFromImmutableState(_getHotelsList);
export const popupDataWithHotelInfoSelector = createSelector(
  [popupDataSelector, getHotelsList],
  (popupData, hotelsList) => {
    if (!popupData) {
      return undefined;
    }

    const popupHotelId = Number(popupData.hotelId);
    const hotelInfo = hotelsList.find(({ hotel }) => hotel.id === popupHotelId);

    const result = {
      ...popupData,
      hotelInfo,
    };

    return result;
  },
);
